import { put, select } from "redux-saga/effects";

import actions from "@/actions";

import Tools from "../../components/features/map-container/tools-bar/tools";

/**
 * Persists the pending group geometry to the global store and returns to view mode.
 *
 * @yields Selects group geometry and dispatches persistence actions.
 */
function* persistGroup() {
    try {
        const { pendingGroupGeometry } = yield select(({ map }) => ({
            pendingGroupGeometry: map.general.pendingGroupGeometry,
        }));

        if (pendingGroupGeometry) {
            yield put(
                actions.map.values.global.addGroupGeometry(
                    pendingGroupGeometry,
                ),
            );
        }

        yield put(actions.map.general.changeMode("view"));
        yield put(actions.map.general.selectTool(Tools.group));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on persisting group:", err);
    }
}

export default persistGroup;
